// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"pageTitle--1uq0e"};